module.exports = __webpack_public_path__ + "img/dpost_desktop1.fa79b4f4.png";